export default __webpack_public_path__ + "static/media/Animals-24.d3a69654.png";